import { SPORTS_BOOK_ROUTE } from "@hypexone/uicore";

/**
 * Menu links that send a logged-out user to login instead of opening.
 *
 * The casino lobby (/casino) is public, as on Sky: browsing it needs no login,
 * and opening a game from it already asks for one (casino.hook's game click
 * shows the login dialog). Launching a game (/dc/...) and the sportsbook do
 * need a session.
 */
export const requiresLoginForNavigation = (navigationUrl: string): boolean =>
  navigationUrl.startsWith("/dc/") ||
  navigationUrl === SPORTS_BOOK_ROUTE ||
  navigationUrl.startsWith(`${SPORTS_BOOK_ROUTE}/`);
